import React from "react";
import {
  MOBILE_LIST_ACTIVE_FILTER_CHIP_BUTTON_CLASS,
  MOBILE_LIST_ACTIVE_FILTER_CHIPS_ROW_CLASS,
  MOBILE_LIST_CLEAR_FILTER_BUTTON_CLASS,
} from "./mobileListUtils";

export default function MobileListActiveFilterChips({
  chips,
  activeFilterStyle,
  onResetChip,
  onClearAll,
}) {
  if (!chips.length) return null;

  return (
    <div className={MOBILE_LIST_ACTIVE_FILTER_CHIPS_ROW_CLASS}>
      {chips.map((chip) => (
        <button
          key={chip.key}
          onClick={() => onResetChip(chip.key)}
          className={MOBILE_LIST_ACTIVE_FILTER_CHIP_BUTTON_CLASS}
          style={activeFilterStyle}
        >
          {chip.label} <span className="text-[8px] ml-0.5">✕</span>
        </button>
      ))}
      <button
        onClick={onClearAll}
        className={MOBILE_LIST_CLEAR_FILTER_BUTTON_CLASS}
      >
        모두 해제
      </button>
    </div>
  );
}
